import { render, staticRenderFns } from "./passwordEdit.vue?vue&type=template&id=1ae0de93&scoped=true&"
import script from "./passwordEdit.vue?vue&type=script&lang=ts&"
export * from "./passwordEdit.vue?vue&type=script&lang=ts&"
import style0 from "./passwordEdit.vue?vue&type=style&index=0&id=1ae0de93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae0de93",
  null
  
)

export default component.exports